"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpClientImpl = void 0;
class HttpClientImpl {
    constructor(options, lambda) {
        this.get = async (url) => {
            return this.options.axiosInstance.get(url, await this.getConfig());
        };
        this.post = async (url, data) => {
            var _a;
            return (_a = this.options.axiosInstance) === null || _a === void 0 ? void 0 : _a.post(url, data, await this.getConfig());
        };
        this.put = async (url, data) => {
            var _a;
            return (_a = this.options.axiosInstance) === null || _a === void 0 ? void 0 : _a.put(url, data, await this.getConfig());
        };
        this.patch = async (url, data) => {
            var _a;
            return (_a = this.options.axiosInstance) === null || _a === void 0 ? void 0 : _a.patch(url, data, await this.getConfig());
        };
        this.delete = async (url, data) => {
            var _a;
            let config = await this.getConfig();
            if (data) {
                config = Object.assign(Object.assign({}, config), { data });
            }
            return (_a = this.options.axiosInstance) === null || _a === void 0 ? void 0 : _a.delete(url, config);
        };
        this.postFile = async (url, data) => {
            var _a;
            const config = await this.getConfig();
            // @ts-ignore
            config.headers['Content-Type'] = 'multipart/form-data';
            return (_a = this.options.axiosInstance) === null || _a === void 0 ? void 0 : _a.post(url, data, config);
        };
        this.getConfig = async () => {
            var _a, _b, _c;
            const config = this.options.getConfig();
            if ((((_a = this.options) === null || _a === void 0 ? void 0 : _a.environment) === 'development' || ((_b = this.options) === null || _b === void 0 ? void 0 : _b.environment) === 'dev') &&
                ((_c = this.options) === null || _c === void 0 ? void 0 : _c.lambda) &&
                this.lambda) {
                // @ts-ignore
                config.baseURL = this.options.axiosInstance.defaults.baseURL + '2';
            }
            return config;
        };
        this.options = options;
        this.lambda = lambda;
    }
}
exports.HttpClientImpl = HttpClientImpl;
